import { render, staticRenderFns } from "./LoadingText.vue?vue&type=template&id=91e71bc2"
import script from "./LoadingText.vue?vue&type=script&lang=js"
export * from "./LoadingText.vue?vue&type=script&lang=js"
import style0 from "./LoadingText.vue?vue&type=style&index=0&id=91e71bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports